import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragHandleIcon from '@mui/icons-material/DragHandle';

export default function QuoteSortableLineRow({ id, children }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.45 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`quote-form-row product-row${isDragging ? ' quote-line-row--dragging' : ''}`}
    >
      <div
        className="quote-line-drag-handle"
        ref={setActivatorNodeRef}
        style={{ touchAction: 'none' }}
        aria-label="Drag to reorder line"
        {...attributes}
        {...listeners}
      >
        <DragHandleIcon fontSize="small" />
      </div>
      {children}
    </div>
  );
}
